/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index'

let exports = {};

exports.saveNotice = function (postData, callback) {// 保存卖家和公告
    api.post('/sh/notice/save/do')
    .data(postData)
    .done(callback)
    .go();
};

exports.updateNoticeDisabled = function (postData, callback) {// 启/禁用公告
    api.post('/sh/notice/disabled/update/do')
    .data(postData)
    .done(callback)
    .go();
};

exports.publishNotice = function (params, callback) {// 发布公告
    api.post('/sh/notice/publish/do')
    .params(params)
    .done(callback)
    .go();
};

exports.updateNotice = function (postData, callback) {// 修改公告
    api.post('/sh/notice/update/do')
    .data(postData)
    .done(callback)
    .go();
};

exports.getNoticeList = function (postData, callback) {// 查看公告列表
    api.post('/sh/notice/list/get')
    .data(postData)
    .done(callback)
    .go();
};

exports.getNoticeInfo = function (params, callback) {// 获取二手货公告
    api.get('/sh/notice/info/get')
    .params(params)
    .done(callback)
    .go();
};

exports.getNoticeTypeList = function (postData, callback) {// 获取公告类型列表
    api.post('/sh/notice/type/list/get')
    .data(postData)
    .done(callback)
    .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/shNotice.js
// module id = 274
// module chunks = 0